import GroupInviteSC from "./group_invite.styles";

const GroupInviteBanner = ({ ref }) => {
    return <GroupInviteSC>
        <div ref={ref} className="group-invite-holder">
            <div className="tg-content">
                <h2>Join Our Community</h2>
                <p>A safe, confidential space for individuals experiencing anxiety, depression, and emotional stress — guided by a trained counselor to foster shared understanding, support, and healthy coping strategies.</p>
            </div>

            <button className="tg-button" onClick={() => { window.open("https://docs.google.com/forms/d/e/1FAIpQLSdK7mlsFbX-5ee8t1vJ_EPRRegLXt2YevAlLFDgdr-jqMGxfA/viewform", "_blank") }}>
                <span className="tg-icon">✈</span>
                Click Here
            </button>
        </div>
    </GroupInviteSC >
};

export default GroupInviteBanner;